var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface70707"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(53.333336%,57.254905%,69.01961%)",
      fillOpacity: 1
    },
    d: "M 24 4 L 6 4 C 4.894531 4 4 4.894531 4 6 L 4 24 C 4 25.105469 4.894531 26 6 26 L 24 26 C 25.105469 26 26 25.105469 26 24 L 26 6 C 26 4.894531 25.105469 4 24 4 Z M 10.953125 22 L 8.003906 22 L 8.003906 12.507812 L 10.953125 12.507812 Z M 9.449219 11.152344 C 8.496094 11.152344 7.730469 10.378906 7.730469 9.429688 C 7.730469 8.480469 8.5 7.710938 9.449219 7.710938 C 10.398438 7.710938 11.167969 8.484375 11.167969 9.429688 C 11.167969 10.378906 10.398438 11.152344 9.449219 11.152344 Z M 22.003906 22 L 19.054688 22 L 19.054688 17.382812 C 19.054688 16.28125 19.035156 14.867188 17.523438 14.867188 C 15.988281 14.867188 15.753906 16.066406 15.753906 17.304688 L 15.753906 22 L 12.804688 22 L 12.804688 12.507812 L 15.632812 12.507812 L 15.632812 13.804688 L 15.675781 13.804688 C 16.066406 13.058594 17.03125 12.273438 18.464844 12.273438 C 21.453125 12.273438 22.003906 14.238281 22.003906 16.792969 Z M 22.003906 22 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0e2300bfc0acdc64e6e9770aadf2dcd6.svg";
export { ForwardRef as ReactComponent };